/**
 * @generated SignedSource<<a635cedfbc82028ddf7907879e8767bb>>
 * @relayHash 3d2826269be363dd9bae3375a49e680c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d2826269be363dd9bae3375a49e680c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PullRequestAndBranchPickerSearchQuery$variables = {
  assignee: string;
  author: string;
  commenters: string;
  first?: number | null | undefined;
  mentions: string;
  open: string;
  queryIsUrl: boolean;
  resource: string;
};
export type PullRequestAndBranchPickerSearchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PullRequestAndBranchPickerQuery">;
};
export type PullRequestAndBranchPickerSearchQuery = {
  response: PullRequestAndBranchPickerSearchQuery$data;
  variables: PullRequestAndBranchPickerSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assignee"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "author"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commenters"
},
v3 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mentions"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "open"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryIsUrl"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resource"
},
v8 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v9 = {
  "kind": "Literal",
  "name": "type",
  "value": "ISSUE"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = [
  (v10/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "number",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDraft",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isInMergeQueue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameWithOwner",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "login",
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": (v12/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PullRequestAndBranchPickerSearchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PullRequestAndBranchPickerQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "PullRequestAndBranchPickerSearchQuery",
    "selections": [
      {
        "alias": "commenters",
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "commenters"
          },
          (v9/*: any*/)
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "alias": "mentions",
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "mentions"
          },
          (v9/*: any*/)
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "alias": "assignee",
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "assignee"
          },
          (v9/*: any*/)
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "alias": "author",
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "author"
          },
          (v9/*: any*/)
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "alias": "open",
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "open"
          },
          (v9/*: any*/)
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "condition": "queryIsUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "resource"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3d2826269be363dd9bae3375a49e680c",
    "metadata": {},
    "name": "PullRequestAndBranchPickerSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1016aad0a11ed4c529533efc883319b0";

export default node;
